@if (items() !== null) {
    <gridster [options]="options">
        @let widgets = store.widgetsData();

        @let errorsItem = items()?.['errorsInFolder'] || null;
        @if (store.canShowErrorsInFolder() && errorsItem) {
            <gridster-item [item]="errorsItem"
                (itemChange)="itemChanged($event)">
                <app-widget [item]="errorsItem" [widgetContentTemplate]="errorsInFolder"
                    [emptyState]="false"
                    (itemChangedEvent)="itemChanged($event)">
                    <ng-template #errorsInFolder>
                        <app-errors-in-folder-widget
                            [serviceIds]="store.healthCareServiceIds()"
                        ></app-errors-in-folder-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (store.canShowLowMedication()) {
            @if (widgets[ServicesDashboardWidgetsEnum.LOW_MEDICATION]?.length && items()?.[ServicesDashboardWidgetsEnum.LOW_MEDICATION]) {
                <gridster-item
                    [item]="items()![ServicesDashboardWidgetsEnum.LOW_MEDICATION]"
                    (itemChange)="itemChanged($event)"
                >
                    <app-widget
                        [item]="items()![ServicesDashboardWidgetsEnum.LOW_MEDICATION]"
                        [widgetContentTemplate]="lowMedication"
                        [prefix]="prefix"
                    >
                        <ng-template #lowMedication>
                            <app-low-medication-widget
                                [items]="widgets[ServicesDashboardWidgetsEnum.LOW_MEDICATION]"
                            ></app-low-medication-widget>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }
        }

        @if (widgets[ServicesDashboardWidgetsEnum.RISKY_CLIENTS]?.length && items()?.[ServicesDashboardWidgetsEnum.RISKY_CLIENTS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.RISKY_CLIENTS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.RISKY_CLIENTS]"
                    [widgetContentTemplate]="riskyClients"
                    [prefix]="prefix"
                >
                    <ng-template #riskyClients>
                        <app-risky-clients-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.RISKY_CLIENTS]"
                        ></app-risky-clients-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (store.isAllowed('voucherDeadline.read')()) {
            @if (widgets[ServicesDashboardWidgetsEnum.NEAR_END_VOUCHERS]?.length && items()?.[ServicesDashboardWidgetsEnum.NEAR_END_VOUCHERS]) {
                <gridster-item
                    [item]="items()![ServicesDashboardWidgetsEnum.NEAR_END_VOUCHERS]"
                    (itemChange)="itemChanged($event)"
                >
                    <app-widget
                        [item]="items()![ServicesDashboardWidgetsEnum.NEAR_END_VOUCHERS]"
                        [widgetContentTemplate]="nearEndVouchers"
                        [prefix]="prefix"
                        [headerLabel]="items()![ServicesDashboardWidgetsEnum.NEAR_END_VOUCHERS].headerTitle"
                    >
                        <ng-template #nearEndVouchers>
                            <app-near-end-vouchers-widget
                                [items]="widgets[ServicesDashboardWidgetsEnum.NEAR_END_VOUCHERS]"
                            ></app-near-end-vouchers-widget>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }
        }

        @if (widgets[ServicesDashboardWidgetsEnum.CELEBRATIONS]?.length && items()?.[ServicesDashboardWidgetsEnum.CELEBRATIONS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.CELEBRATIONS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.CELEBRATIONS]"
                    [widgetContentTemplate]="celebratrions"
                    [prefix]="prefix"
                >
                    <ng-template #celebratrions>
                        <app-celebrations-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.CELEBRATIONS]"
                        ></app-celebrations-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.MAIL_RECORDS]?.length && items()?.[ServicesDashboardWidgetsEnum.MAIL_RECORDS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.MAIL_RECORDS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.MAIL_RECORDS]"
                    [widgetContentTemplate]="mailRecords"
                    [prefix]="prefix"
                >
                    <ng-template #mailRecords>
                        <app-mail-records-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.MAIL_RECORDS]"
                        ></app-mail-records-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.MOVEMENT_RESTRICTIONS]?.length && items()?.[ServicesDashboardWidgetsEnum.MOVEMENT_RESTRICTIONS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.MOVEMENT_RESTRICTIONS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.MOVEMENT_RESTRICTIONS]"
                    [widgetContentTemplate]="movementRestrictions"
                    [prefix]="prefix"
                >
                    <ng-template #movementRestrictions>
                        <app-work-movement-restriction-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.MOVEMENT_RESTRICTIONS]"
                        ></app-work-movement-restriction-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.SANCTION]?.length && items()?.[ServicesDashboardWidgetsEnum.SANCTION]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.SANCTION]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.SANCTION]"
                    [widgetContentTemplate]="sanction"
                    [prefix]="prefix"
                >
                    <ng-template #sanction>
                        <app-work-sanction-dashboard-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.SANCTION]"
                        ></app-work-sanction-dashboard-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.SUGGESTION]?.length && items()?.[ServicesDashboardWidgetsEnum.SUGGESTION]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.SUGGESTION]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.SUGGESTION]"
                    [widgetContentTemplate]="suggestion"
                    [prefix]="prefix"
                >
                    <ng-template #suggestion>
                        <app-work-suggestion-dashboard-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.SUGGESTION]"
                        ></app-work-suggestion-dashboard-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.INDIVIDUAL_PLAN]?.length && items()?.[ServicesDashboardWidgetsEnum.INDIVIDUAL_PLAN]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.INDIVIDUAL_PLAN]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.INDIVIDUAL_PLAN]"
                    [widgetContentTemplate]="individualPlan"
                    [prefix]="prefix"
                >
                    <ng-template #individualPlan>
                        <app-social-service-individual-plan-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.INDIVIDUAL_PLAN]"
                        ></app-social-service-individual-plan-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.CLIENTS_WITHOUT_RECENT_WORK]?.length && items()?.[ServicesDashboardWidgetsEnum.CLIENTS_WITHOUT_RECENT_WORK]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.CLIENTS_WITHOUT_RECENT_WORK]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.CLIENTS_WITHOUT_RECENT_WORK]"
                    [widgetContentTemplate]="clientsWithoutRecentWork"
                    [prefix]="prefix"
                    [headerLabel]="items()![ServicesDashboardWidgetsEnum.CLIENTS_WITHOUT_RECENT_WORK].headerTitle"
                >
                    <ng-template #clientsWithoutRecentWork>
                        <app-clients-without-recent-work-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.CLIENTS_WITHOUT_RECENT_WORK]"
                        ></app-clients-without-recent-work-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.PLANNED_WORK]?.length && items()?.[ServicesDashboardWidgetsEnum.PLANNED_WORK]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.PLANNED_WORK]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.PLANNED_WORK]"
                    [widgetContentTemplate]="plannedWork"
                    [prefix]="prefix"
                >
                    <ng-template #plannedWork>
                        <app-planned-work-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.PLANNED_WORK]"
                        ></app-planned-work-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.DEBTORS]?.length && items()?.[ServicesDashboardWidgetsEnum.DEBTORS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.DEBTORS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.DEBTORS]"
                    [widgetContentTemplate]="debtors"
                    [prefix]="prefix"
                >
                    <ng-template #debtors>
                        <app-debtors-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.DEBTORS]"
                        ></app-debtors-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.OPERATIONAL_REPORTS]?.length && items()?.[ServicesDashboardWidgetsEnum.OPERATIONAL_REPORTS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.OPERATIONAL_REPORTS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.OPERATIONAL_REPORTS]"
                    [widgetContentTemplate]="operationalReports"
                    [prefix]="prefix"
                >
                    <ng-template #operationalReports>
                        <app-operational-reports-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.OPERATIONAL_REPORTS]"
                        ></app-operational-reports-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.FINANCIAL_BALANCE]?.length && items()?.[ServicesDashboardWidgetsEnum.FINANCIAL_BALANCE]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.FINANCIAL_BALANCE]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    class="chart-widget"
                    [item]="items()![ServicesDashboardWidgetsEnum.FINANCIAL_BALANCE]"
                    [widgetContentTemplate]="financialBalance"
                    [prefix]="prefix"
                >
                    <ng-template #financialBalance>
                        <app-financial-balance-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.FINANCIAL_BALANCE]"
                        ></app-financial-balance-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.PERFORMED_WORK]?.length && items()?.[ServicesDashboardWidgetsEnum.PERFORMED_WORK]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.PERFORMED_WORK]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    class="chart-widget"
                    [item]="items()![ServicesDashboardWidgetsEnum.PERFORMED_WORK]"
                    [widgetContentTemplate]="performedWork"
                    [prefix]="prefix"
                >
                    <ng-template #performedWork>
                        <app-performed-work-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.PERFORMED_WORK]"
                        ></app-performed-work-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.WORKED_HOURS]?.length && items()?.[ServicesDashboardWidgetsEnum.WORKED_HOURS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.WORKED_HOURS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    class="chart-widget"
                    [item]="items()![ServicesDashboardWidgetsEnum.WORKED_HOURS]"
                    [widgetContentTemplate]="workedHours"
                    [prefix]="prefix"
                >
                    <ng-template #workedHours>
                        <app-worked-hours-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.WORKED_HOURS]"
                        ></app-worked-hours-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.WORKERS_WORKED_HOURS]?.length && items()?.[ServicesDashboardWidgetsEnum.WORKERS_WORKED_HOURS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.WORKERS_WORKED_HOURS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    class="chart-widget"
                    [item]="items()![ServicesDashboardWidgetsEnum.WORKERS_WORKED_HOURS]"
                    [widgetContentTemplate]="workersWorkedHours"
                    [prefix]="prefix"
                >
                    <ng-template #workersWorkedHours>
                        <app-workers-worked-hours-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.WORKERS_WORKED_HOURS]"
                        ></app-workers-worked-hours-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.USER_TASKS]?.length && items()?.[ServicesDashboardWidgetsEnum.USER_TASKS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.USER_TASKS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.USER_TASKS]"
                    [widgetContentTemplate]="userTasks"
                    [prefix]="prefix"
                >
                    <ng-template #userTasks>
                        <app-social-service-user-tasks-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.USER_TASKS]"
                        ></app-social-service-user-tasks-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.USER_MESSAGES]?.length && items()?.[ServicesDashboardWidgetsEnum.USER_MESSAGES]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.USER_MESSAGES]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.USER_MESSAGES]"
                    [widgetContentTemplate]="userMessages"
                    [prefix]="prefix"
                >
                    <ng-template #userMessages>
                        <app-user-messages-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.USER_MESSAGES]"
                        ></app-user-messages-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.SERVICE_ANNOUNCEMENTS]?.length && items()?.[ServicesDashboardWidgetsEnum.SERVICE_ANNOUNCEMENTS]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.SERVICE_ANNOUNCEMENTS]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.SERVICE_ANNOUNCEMENTS]"
                    [widgetContentTemplate]="serviceAnnouncements"
                    [prefix]="prefix"
                >
                    <ng-template #serviceAnnouncements>
                        <app-work-service-announcement-dashboard-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.SERVICE_ANNOUNCEMENTS]"
                        ></app-work-service-announcement-dashboard-widget>
                    </ng-template>
                </app-widget>
            </gridster-item>
        }
        @if (widgets[ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_DURATION]?.length && items()?.[ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_DURATION]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_DURATION]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_DURATION]"
                    [widgetContentTemplate]="nursingAllowanceDuration"
                    [prefix]="prefix"
                >
                    <ng-template #nursingAllowanceDuration>
                        <app-nursing-allowance-duration-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_DURATION]"
                        />
                    </ng-template>
                </app-widget>
            </gridster-item>
        }

        @if (widgets[ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_CONFIRMATION]?.length && items()?.[ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_CONFIRMATION]) {
            <gridster-item
                [item]="items()![ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_CONFIRMATION]"
                (itemChange)="itemChanged($event)"
            >
                <app-widget
                    [item]="items()![ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_CONFIRMATION]"
                    [widgetContentTemplate]="nursingAllowanceConfirmation"
                    [prefix]="prefix"
                >
                    <ng-template #nursingAllowanceConfirmation>
                        <app-nursing-allowance-confirmation-widget
                            [items]="widgets[ServicesDashboardWidgetsEnum.NURSING_ALLOWANCE_CONFIRMATION]"
                        />
                    </ng-template>
                </app-widget>
            </gridster-item>
        }
    </gridster>
}
